export default __webpack_public_path__ + "static/media/group-7029.efe6494b.png";